export default "__VITE_ASSET__C30T8UOM__"